<div class="row">
  <div class="col-12 py-2 px-0">
    <div class="row justify-content-center">
      <!-- Summary -->
      <div class="col-8">
        <h1>Your Profile</h1>
        <p class="card-text">
          The credentials we have on record for you, based on the values entered
          during registration. We hope they are correct, please let us know if
          there are any errors.
        </p>
      </div>
    </div>
    <!-- Profile card -->
    <div class="col-12 py-2 px-0">
      <div class="card px-0">
        <div class="card-block bg-faded py-5">
          <h2 class="card-title pb-3">Profile details</h2>
          <div class="row justify-content-center">
            <div class="col-md-8 py-2">
              <table class="text-left">
                <tr>
                  <td class="px-sm-5 px-2 mx-2">
                    <strong>First name:</strong>
                  </td>
                  <td class="px-sm-5 px-2 mx-2">{{ firstName }}</td>
                </tr>
                <tr>
                  <td class="px-sm-5 px-2 mx-2"><strong>Last name:</strong></td>
                  <td class="px-sm-5 px-2 mx-2">{{ lastName }}</td>
                </tr>
                <tr>
                  <td class="px-sm-5 px-2 mx-2"><strong>User name:</strong></td>
                  <td class="px-sm-5 px-2 mx-2">{{ userName }}</td>
                </tr>
                <tr>
                  <td class="px-sm-5 px-2 mx-2">
                    <strong>E-mail address:</strong>
                  </td>
                  <td class="px-sm-5 px-2 mx-2">{{ eMail }}</td>
                </tr>
                <tr>
                  <td class="px-sm-5 px-2 mx-2">
                    <strong>Phone number:</strong>
                  </td>
                  <td class="px-sm-5 px-2 mx-2">{{ phoneN }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
